import { FC, useState } from 'react';

import { useTheme } from 'styled-components';

import { useMediaQuery } from '~/common/hooks/use-media-query';
import { Typography } from '~/common/components/Typograph';
import { Modal } from '~/common/components/Modal';
import { Button } from '~/common/components/Button';

interface IDeletePromptConfirmationProps {
  title: string;
  open: boolean;
  close: () => void;
  confirm: () => Promise<void>;
}
export const DeletePromptConfirmation: FC<IDeletePromptConfirmationProps> = ({
  title,
  open,
  close,
  confirm,
}) => {
  const isMobile = useMediaQuery('(max-width: 750px)');
  const [loading, setLoading] = useState(false);
  const theme = useTheme();

  const handleConfirm = async (): Promise<void> => {
    setLoading(true);
    await confirm().finally(() => setLoading(false));
  };

  return (
    <Modal
      isOpen={open}
      onClose={close}
      id="delete-prompt-modal"
      height={isMobile ? '200px' : 'auto'}
      width="400px"
      title="Atenção"
      {...(isMobile && {
        style: {
          marginBottom: 'auto',
        },
      })}
    >
      <Typography.Label size="medium" color="neutral0">
        {`Confirma a exclusão do prompt "${title}"? Esta ação não pode ser
        desfeita.`}
      </Typography.Label>

      <Button
        text="Confirmar"
        width="100%"
        backgroundColor={theme.red}
        onClick={handleConfirm}
        loader="bar"
        loading={loading}
        loaderColor="neutral0"
        borderColor={theme.transparent}
      />
    </Modal>
  );
};
